import {Module, VuexModule, Mutation, Action, getModule} from 'vuex-module-decorators';

import store from '../index';
import {User, JwtTokenRs, SignInRq, SetPasswordRq} from '@/types/auth';
import ModuleApi from '@/store/api';


@Module({
    name: 'auth',
    dynamic: true,
    namespaced: true,
    store,
})
class ModuleAuth extends VuexModule {
    // Is user successfully authenticated in the app
    private authenticated: boolean = false;
    // The authorized user
    private user: User | undefined

    @Mutation
    public loginSuccessfull(user: User) {
        this.user = user;
        this.authenticated = true;
    }

    @Mutation
    public resetLoginStatus() {
        localStorage.removeItem("token");
        this.authenticated = false;
    }

    //Logout from cabinet
    @Action
    logout() {
        this.context.commit("resetLoginStatus");
    }

    @Action
    async attemptLogin() {
        try {
            const user = await ModuleApi.GET('/api/cabinet/auth/user-info') as User;
            this.context.commit("loginSuccessfull", user);
        } catch (err) {
            // token is invalid/expired or server is down
            this.context.commit("resetLoginStatus");
        }
    }

    //SignIn in cainet
    @Action
    async signIn(creds: SignInRq) {
        const jwtTokenRs = await ModuleApi.POST({url: '/api/cabinet/auth/sign-in', body: creds}) as JwtTokenRs;
        localStorage.setItem('token', jwtTokenRs.jwtToken);
        const user = await ModuleApi.GET('/api/cabinet/auth/user-info') as User;
        this.context.commit("loginSuccessfull", user);
    }

    //Change specialist password for Setting.vue
    @Action
    public async changePassword(password: SetPasswordRq) {
        await ModuleApi.PUT({url: '/api/cabinet/auth/set-password', body: password})
    }

    public get isAuthenticated(): boolean {
        return this.authenticated;
    }

    public get userLoggedIn(): User | undefined {
        return this.user;
    }
}

export default getModule(ModuleAuth);
